import React from 'react';

function Footer() {
    return (
      <footer className="footer">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-6 mb-3">
          <img src="../assets/images/MMB_LOGO/WebdekhoOldLogo.png" height={30}/>

          </div>
          <div className="col-sm-6">
            <div className="text-sm-end d-none d-sm-block">
              {/* Design &amp; Develop by{" "} */}
                {/* <img src="../assets/images/MMB_LOGO/WebdekhoOldLogo.png" height={30}/> */}
                @MMB.
            </div>
          </div>
        </div>
      </div>
    </footer>
    
      
    );
  }
  
  export default Footer;
  